<script>
import template from './template.html';
import helpers from '@/utils/helpers';
import store from '@/store';
import Menu from '@/shared/menu/store';
import { MSG_TITLE, MSG_TYPE } from '@/utils/messages';

import { mapActions, mapMutations } from 'vuex';
export default {
    name: 'ItemLeftMenu',
    template: template,
    beforeCreate() {
        if (!store.hasModule('Menu')) {
            store.registerModule('Menu', Menu);
        }
    },
    props: {
        item: Object,
        index: Number,
        classMore: {
            type: Object,
            default() {
                return {};
            }
        },
        isChild: {
            type: Boolean,
            default: false
        },
        funcCloseChildMenu: {
            type: Function
        }
    },
    data() {
        return {
            isMobile: helpers.checkIfMobile()
        };
    },
    created() {},
    mounted() {},
    methods: {
        ...mapActions('Menu', ['referItem']),
        ...mapMutations('app', [
            'showHeaderError',
            'setScreenId',
            'setHeader',
            'showModalMessage',
            'hideModalMessage',
            'hideHeaderError',
            'setShowLeftMenu'
        ]),
        ...mapMutations('app', ['setRouteProps']),
        open_pdf() {
            const userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.referItem({
                department_cd: userInfo.department_cd,
                callback: (response) => {
                    if (response.Data.file_name) {
                        this.statusBtnWorkRequest = false;
                        const { href } = this.$router.resolve({
                            name: 'PreviewPdf',
                            params: {
                                file_name: response.Data.file_name,
                                path: response.Data.file_name,
                                type: 5
                            }
                        });
                        window.open(`${window.location.origin}${href}`, '_blank');
                    } else {
                        this.showModalMessage({
                            type: MSG_TYPE.ERROR,
                            title: MSG_TITLE.S001,
                            content: '該当ファイルは存在しませんでした。',
                            okText: 'OK'
                        });
                    }
                },
                onError: (error) => {
                    console.log(error);
                }
            });
        },

        handleMenuNavigation(menuItem) {
            if (menuItem.staticFile) {
                window.open('/sample/' + menuItem.staticFile);
                return;
            }
            // If routeProps exist, set them to store before navigation
            if (menuItem.routeProps) {
                const routeName = menuItem.routeNameRelative || menuItem.to.replace('/', ''); // Remove leading slash
                this.setRouteProps({
                    routeName,
                    props: menuItem.routeProps
                });
            }

            // Handle different target types
            if (menuItem.newTab) {
                // Open in new tab/window
                const { href } = this.$router.resolve(menuItem.to);
                window.open(`${window.location.origin}${href}`, '_blank');
            } else {
                // Navigate in same window
                this.$router.push(menuItem.to);
                this.setShowLeftMenu(false);
                this.funcCloseChildMenu();
            }
        }
    }
};
</script>
